import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VisualItineraryComponent } from './visual-itinerary.component';
import { GenericTextModule } from '@finder/shared/components/generic-text/generic-text.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
        GenericTextModule,
        SafeHtmlPipeModule
    ],
    declarations: [
        VisualItineraryComponent
    ],
    exports: [
        VisualItineraryComponent
    ]
})
export class VisualItineraryModule { }
